"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _withAuth = _interopRequireDefault(require("./withAuth"));

var _UriUtils = _interopRequireDefault(require("./utils/UriUtils"));

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _withAuth.default)((_temp = _class = /*#__PURE__*/function (_Component) {
  _inherits(SecureRoute, _Component);

  var _super = _createSuper(SecureRoute);

  function SecureRoute(props) {
    var _this;

    _classCallCheck(this, SecureRoute);

    _this = _super.call(this, props);
    _this.state = {
      authenticated: null,
      accessDenied: null
    };
    _this.checkAuthentication = _this.checkAuthentication.bind(_assertThisInitialized(_this));
    _this.renderWrapper = _this.renderWrapper.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SecureRoute, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkAuthentication();
      this.props.callbackFunction();
    }
  }, {
    key: "checkAuthentication",
    value: function () {
      var _checkAuthentication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$props, auth, requiredRoles, isAuth, userGroups, roleMatchFound, _iterator, _step, _loop, _ret;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, auth = _this$props.auth, requiredRoles = _this$props.requiredRoles;
                _context.next = 3;
                return auth.forceIsAuthenticated();

              case 3:
                isAuth = _context.sent;

                if (!(isAuth !== this.state.authenticated)) {
                  _context.next = 39;
                  break;
                }

                if (!isAuth) {
                  _context.next = 38;
                  break;
                }

                if (!(requiredRoles && requiredRoles.length)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 9;
                return auth.getUserGroups();

              case 9:
                userGroups = _context.sent;

                if (userGroups.length) {
                  _context.next = 13;
                  break;
                }

                // User has no roles but we know at least one is required
                this.setState({
                  authenticated: true,
                  accessDenied: true
                });
                return _context.abrupt("return");

              case 13:
                roleMatchFound = false;
                _iterator = _createForOfIteratorHelper(requiredRoles);
                _context.prev = 15;

                _loop = function _loop() {
                  var role = _step.value;

                  if (userGroups.find(function (r) {
                    return r === role;
                  })) {
                    roleMatchFound = true;
                    return "break";
                  }
                };

                _iterator.s();

              case 18:
                if ((_step = _iterator.n()).done) {
                  _context.next = 24;
                  break;
                }

                _ret = _loop();

                if (!(_ret === "break")) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("break", 24);

              case 22:
                _context.next = 18;
                break;

              case 24:
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](15);

                _iterator.e(_context.t0);

              case 29:
                _context.prev = 29;

                _iterator.f();

                return _context.finish(29);

              case 32:
                this.setState({
                  authenticated: true,
                  accessDenied: !roleMatchFound
                });
                _context.next = 36;
                break;

              case 35:
                this.setState({
                  authenticated: true,
                  accessDenied: false
                });

              case 36:
                _context.next = 39;
                break;

              case 38:
                this.setState({
                  authenticated: false,
                  accessDenied: false
                });

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[15, 26, 29, 32]]);
      }));

      function checkAuthentication() {
        return _checkAuthentication.apply(this, arguments);
      }

      return checkAuthentication;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAuthentication();
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(renderProps) {
      var _this$props2 = this.props,
          loginPath = _this$props2.loginPath,
          forbiddenURL = _this$props2.forbiddenURL,
          Component = _this$props2.component,
          render = _this$props2.render,
          requiresSearchQuery = _this$props2.requiresSearchQuery;
      var _this$state = this.state,
          authenticated = _this$state.authenticated,
          accessDenied = _this$state.accessDenied;

      if (authenticated === null) {
        return null;
      }

      if (!(process.env.TEST === 'true' && window.localStorage.getItem('okta-token-storage-test')) && accessDenied === true) {
        if (!!forbiddenURL) {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: forbiddenURL
          });
        } else {
          return /*#__PURE__*/_react.default.createElement("div", {
            style: {
              padding: 40
            }
          }, /*#__PURE__*/_react.default.createElement("h1", null, "Forbidden"), /*#__PURE__*/_react.default.createElement("p", null, "You don't have permission to access this page."));
        }
      }

      if (!authenticated) {
        var absoluteTest = new RegExp('^(?:[a-z]+:)?//', 'i');

        if (absoluteTest.test(loginPath)) {
          window.location = loginPath;
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        } else {
          var referrer = _UriUtils.default.getInternalRedirectPath(requiresSearchQuery);

          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: "".concat(loginPath, "?referrer=").concat(referrer)
          });
        }
      }

      return render ? render(renderProps) : /*#__PURE__*/_react.default.createElement(Component, renderProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: this.props.path,
        render: this.renderWrapper
      });
    }
  }]);

  return SecureRoute;
}(_react.Component), _defineProperty(_class, "propTypes", {
  auth: _propTypes.default.object.isRequired,
  component: _propTypes.default.object,
  render: _propTypes.default.func,
  path: _propTypes.default.string.isRequired,
  loginPath: _propTypes.default.string.isRequired,
  requiredRoles: _propTypes.default.arrayOf(_propTypes.default.string),
  forbiddenURL: _propTypes.default.string,
  callbackFunction: _propTypes.default.func,
  requiresSearchQuery: _propTypes.default.bool
}), _defineProperty(_class, "defaultProps", {
  component: null,
  render: null,
  requiredRoles: [],
  forbiddenURL: null,
  callbackFunction: function callbackFunction() {},
  requiresSearchQuery: false
}), _temp));

exports.default = _default;
//# sourceMappingURL=SecureRoute.js.map